'use strict';

import stringSimilarity from 'string-similarity'

angular.module('docketbook').
  controller('importResourcesModalController', function (resourceService, xeroService, $scope, uuid, Upload) {

    $scope.allXeroItems = []
    $scope.filteredXeroItems = []
    $scope.selectedItems = []
    $scope.xeroSyncLoading = false
    $scope.xeroSearchValue = ''
    $scope.stage = 1
    $scope.prefillCategory = null
    $scope.prefillUom = null
    $scope.selectedTabIndex = 0
    $scope.prefilled = {}
    $scope.resourceImport = { loading: false }
    $scope.file = null

    // File import
    $scope.fileStage = 1
    $scope.importSelected = [];

    $scope.xeroQuery = {
      limit: 100,
      page: 1,
      offset: 0,
    };


    $scope.$parent.showImportResourcesModal = function () {
      $scope.stage = 1
      $scope.selectedItems = []
      $scope.xeroSearchValue = ''
      $scope.prefilled = {}
      $scope.selectedTabIndex = 0
      $scope.fileStage = 1
      $scope.resourceImport = { loading: false }
      $scope.file = null
      $('#importResourcesModal').fadeIn(100)
    }

    $scope.back = function () {
      $scope.stage--
    }

    $scope.goToStage2 = function () {
      $scope.stage = 2
    }

    $scope.goToStage3 = function (skip) {
      if (skip) {
        $scope.selectedItems.forEach(item => {
          item.category = null
          item.uom = null
        })
      } else {
        if ($scope.prefilled.category) {
          $scope.selectedItems.forEach(item => {
            item.category = $scope.prefilled.category
          })
        }

        if ($scope.prefilled.uom) {
          $scope.selectedItems.forEach(item => {
            item.uom = $scope.prefilled.uom
          })
        }
      }
      $scope.stage = 3
    }

    $scope.reSyncXeroResources = function () {
      $scope.xeroSyncLoading = true
      xeroService.xeroItemSync(function (taskInfo) {
        if (taskInfo.status == 'Failed') {
          $scope.alertService.presentAlert('error', "We couldn't sync your Xero Items", "Something went wrong when we tried to sync your Xero Items. Please try again or contact support if this error persists.")
          $scope.xeroContactSyncLoading = false;
        } else {
          xeroService.getXeroItems($scope.xeroQuery, function (items) {
            $scope.allXeroItems = items.map(item => {
              var retVal = Object.assign(item, { identifier: item.userCode, xeroId: item.id })
              delete retVal.time
              delete retVal.type
              delete retVal.userCode
              return retVal
            })
            $scope.searchXeroChange($scope.xeroSearchValue)
            $scope.xeroSyncLoading = false
          })
        }
      })
    }

    $scope.close = function () {
      $('#importResourcesModal').fadeOut(100)
    }

    $scope.getXeroItems = function () {
      $scope.xeroQuery.offset = $scope.xeroQuery.limit * ($scope.xeroQuery.page - 1)

      xeroService.getXeroItems($scope.xeroQuery, function (items) {
        $scope.allXeroItems = items.map(item => {
          var retVal = Object.assign(item, { identifier: item.userCode, xeroId: item.id })
          delete retVal.time
          delete retVal.type
          delete retVal.userCode
          return retVal
        })
        $scope.filteredXeroItems = angular.copy(items)

        if ($scope.xeroQuery.offset <= 0 && items.length < $scope.xeroQuery.limit) {
          $scope.xeroListCount = items.length;
        } else {
          $scope.xeroListCount = $scope.xeroQuery.offset + ($scope.xeroQuery.limit + 1);
        }
      })
    }

    $scope.getXeroItems()

    $scope.import = function () {
      var resourcesToAdd = $scope.selectedItems.slice()

      const saveOneResource = () => {
        if (resourcesToAdd.length == 0) {
          $('#importResourcesModal').fadeOut(100)
          $scope.$parent.loadResourceList()
          return
        }

        var resource = Object.assign({}, resourcesToAdd.pop())
        delete resource.id
        resource.uom = resource.uom.id
        resource.category = resource.category.id
        resource.externalIdentifiers = [{ type: 'xero', externalId: resource.externalId }]

        resourceService.saveResource(resource, saveOneResource, function (err) {
          console.error('could not save resource', err)
          saveOneResource()
        })
      }

      saveOneResource()
    }

    $scope.getTableStyle = function () {
      if ($scope.xeroSyncLoading) {
        return { opacity: 0.5 }
      } else {
        return {}
      }
    }

    $scope.formValid = function () {
      return $scope.selectedItems.filter(item =>
        item.name == null
        || item.name == ""
        || item.identifier == null
        || item.identifier == ""
        || item.category == null
        || item.uom == null
      ).length == 0
    }

    $scope.fileFormValid = function () {
      return $scope.importSelected.filter(item =>
        item.name == null
        || item.name == ""
        || item.identifier == null
        || item.identifier == ""
        || item.category == null
        || item.uom == null
        || item.error
      ).length == 0
    }

    $scope.searchXeroChange = function (searchValue) {
      if (searchValue == "") {
        $scope.filteredXeroItems = $scope.allXeroItems;
        return;
      }
      $scope.filteredXeroItems =
        $scope.allXeroItems
          .filter(resource =>
            stringSimilarity.compareTwoStrings(resource.name, searchValue) > 0.3
            || resource.name.toLowerCase().indexOf(searchValue.toLowerCase()) != -1
          )
    }

    $scope.searchUomChange = function (searchText) {
      if (searchText == null || searchText == "") {
        $scope.filteredUoms = angular.copy($scope.allUoms);
      } else {
        $scope.filteredUoms = [];
        for (var i = 0; i < $scope.allUoms.length; i++) {
          if ($scope.allUoms[i].abbreviation.toLowerCase().indexOf(searchText.toLowerCase()) != -1 ||
            $scope.allUoms[i].description.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
            $scope.filteredUoms.push($scope.allUoms[i]);
          }
        }
      }
    }

    $scope.searchCategoryChange = function (searchText) {
      if (searchText == null || searchText == "") {
        $scope.filteredCategories = angular.copy($scope.allResourceCategories);
      } else {
        $scope.filteredCategories = [];
        for (var i = 0; i < $scope.allResourceCategories.length; i++) {
          if ($scope.allResourceCategories[i].name.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
            $scope.filteredCategories.push($scope.allResourceCategories[i]);
          }
        }
      }
    }



    // Fom File

    const mapping = {
      'resource category': 'category',
      'resource id': 'id',
      'resource name': 'name',
      'unit of measure': 'uom',
    }

    const reverseMapping = {}

    Object.keys(mapping)
      .forEach(key => {
        reverseMapping[mapping[key]] = key
      })

    const readTableHeaders = fileData => {
      const headers =
        fileData.shift()
          .map(header => header.toLowerCase())
          .map(header => {
            var found = null
            Object.keys(mapping).forEach(key => {
              if (header.includes(key)) {
                found = mapping[key]
                return
              }
            })
            return found
          })
          .filter(x => x !== null)

      const headerMissing = str => !headers.includes(str)

      const missing = ['category', 'name', 'uom'].filter(headerMissing).map(header => reverseMapping[header])

      if (missing.length > 0) {
        swal({
          title: "Oops!",
          text: `The following columns are missing from the file: ${missing.join(', ')}`,
          type: "error",
          confirmButtonText: "Ok, got it."
        })
        return null
      }

      return fileData.map(data => {
        var item = {}
        headers.forEach((header, i) => {
          item[header] = data[i]
        })
        return item
      })
    }

    $scope.importFromFile = function (fileToImport) {
      $scope.resourceImport.loading = true;

      Upload.upload({
        url: '/v1/parse',
        data: { file: fileToImport },
        withCredentials: true
      }).then(function (resp) {
        var data = readTableHeaders(resp.data[0].data)
        if (data == null) {
          $scope.resourceImport.loading = false;
          return
        }

        $scope.parseResourcesForImport(data);

      }, function (resp) {
        $scope.resourceImport.loading = false;
        $scope.alertService.presentAutoAlert('readFile', resp);
      });
    }

    $scope.parseResourcesForImport = function (data) {
      var resourcesList = [];
      $scope.importSelected = [];


      var existingIds = []

      data
        .filter(line => line.name)
        .forEach(line => {
          var category = $scope.findCategory(line.category)
          var uom = $scope.findUom(line.uom)

          var identifier = line.id
          if (identifier == null) {
            var generatedId = line.name.substring(0, 3).toUpperCase()
            if (existingIds.includes(generatedId)) {
              var generatedNum = 1
              generatedId += '1'

              while (existingIds.includes(generatedId)) {
                generatedNum++
                generatedId = generatedId.substring(0, 3) + generatedNum
              }
            }
            identifier = generatedId
          }

          var newResource = {
            importId: uuid.v4(),
            name: line.name,
            identifier: String(identifier),
            category,
            uom,
            status: 'New'
          }
          $scope.importSelected.push(newResource);
          resourcesList.push(newResource);
        })

      $scope.importList = resourcesList;
      $scope.importList.forEach($scope.validateResourceItem)

      $scope.fileStage = 2
      $scope.resourceImport.loading = false;
    }


    $scope.parseResourcesForImport_OLD = function (importData) {
      var resourcesList = [];
      $scope.importSelected = [];

      for (var i = 0; i < importData.length; i++) {
        for (var j = 0; j < importData[i].data.length; j++) {
          var newResource = {};
          newResource.name = String(importData[i].data[j][0]);
          newResource.identifier = String(importData[i].data[j][1]);
          newResource.category = String(importData[i].data[j][2]);
          newResource.uom = String(importData[i].data[j][3]);
          if (importData[i].data[j].length >= 5) {
            newResource.uuid = importData[i].data[j][4];
          }

          // See if resource exists by uuid
          if (newResource.uuid != '' && newResource.uuid != null) {
            // check if resource actually exists
            var matchedResource = $scope.findExistingResource(newResource.uuid);
            if (matchedResource) {
              newResource.resource = matchedResource;
              newResource.status = 'Update';
            } else {
              newResource.status = 'New';
            }
          } else {
            newResource.status = 'New';
          }

          // Try and match category from list
          var matchedCategory = $scope.findCategory(newResource.category);
          if (matchedCategory) {
            newResource.category = matchedCategory;
          }

          // Try and match uom from list
          var matchedUom = $scope.findUom(newResource.uom);
          if (matchedUom) {
            newResource.uom = matchedUom;
          }

          newResource.importId = uuid.v4();
          $scope.importSelected.push(newResource);
          resourcesList.push(newResource);
        }
      }
      $scope.importList = resourcesList;
      //$scope.importList.forEach($scope.validateResourceItem)
      $scope.validateAllResourceItems()

      $scope.fileStage = 2
      $scope.resourceImport.loading = false;
    }

    $scope.findExistingResource = function (resourceUUID) {
      if (resourceUUID == null || resourceUUID == '') {
        return null;
      }

      for (var i = 0; i < $scope.allResources.length; i++) {
        if ($scope.allResources[i].id == resourceUUID) {
          return $scope.allResources[i];
        }
      }

      return null;
    }


    const searchCategoryBy = (searchTerm, categoryProp) => {
      const closeMatches =
        $scope.allResourceCategories
          .map(category => ({ category, similarity: stringSimilarity.compareTwoStrings(searchTerm, category[categoryProp]) }))
          .filter(x => x.similarity > 0.7)

      if (closeMatches.length > 0) {
        return _.max(closeMatches, x => x.similarity).category
      } else {
        return null
      }
    }

    $scope.findCategory = function (searchTerm) {
      if (searchTerm == '' || searchTerm == null) {
        return null;
      }

      const searchByName = searchCategoryBy(searchTerm, 'name')
      return searchByName ? searchByName : searchCategoryBy(searchTerm, 'description')
    }


    const findUomBy = (searchTerm, uomProp) => {
      const closeMatches =
        $scope.allUoms
          .map(uom => ({ uom, similarity: stringSimilarity.compareTwoStrings(searchTerm, uom[uomProp]) }))
          .filter(x => x.similarity > 0.7)

      if (closeMatches.length > 0) {
        return _.max(closeMatches, x => x.similarity).uom
      } else {
        return null
      }
    }

    $scope.findUom = function (searchTerm) {
      if (searchTerm == '' || searchTerm == null) {
        return null;
      }

      var byAbbrev = findUomBy(searchTerm, 'abbreviation')
      return byAbbrev ? byAbbrev : findUomBy(searchTerm, 'description')
    }

    $scope.validateImportResources = function (importList) {
      var errorCount = 0;
      for (var i = 0; i < importList.length; i++) {
        var thisItemError = $scope.validateResourceItem(importList[i]);
        if (thisItemError == true) {
          errorCount += 1;
        }
      }

      if (errorCount > 0) {
        return false;
      } else {
        return true;
      }
    }

    $scope.bulkImportResources = function () {
      // get selected
      var importList = $scope.importSelected;
      $scope.resourceImport.loading = true

      if ($scope.validateImportResources(importList) != true) {
        // validation failed
        $scope.alertService.presentAlert('warning', "Hold Up!", "Some resources do not have categorys or UOMs matched or non-unique identifiers! Please check and try again.");
        $scope.resourceImport.loading = false
        return;
      }

      // compile object of resources to be imported from list
      var resourcesSave = [];
      for (var i = 0; i < importList.length; i++) {
        if (importList[i].selected) {
          var resource = {};
          resource.name = importList[i].name;
          resource.identifier = importList[i].identifier;
          resource.category = importList[i].category.id;
          resource.uom = importList[i].uom.id;
          resource.organisation = $scope.currentOrg.id;
          resourcesSave.push(resource);
        }
      }

      resourceService.bulkImportResources(resourcesSave, function (resp) {
        $scope.mode = 'list';
        $scope.refreshResources();
        $scope.importList = [];
        $scope.close();
        $scope.resourceImport.loading = false
      }, function (err) {
        $scope.alertService.presentAutoAlert('importResources', err);
        $scope.resourceImport.loading = false
      });
    }

    $scope.removeResourceFromImport = function (resource, importList) {
      var index = importList.indexOf(resource);
      if (index != -1) {
        importList.splice(index, 1);
      }

      index = $scope.importSelected.indexOf(resource);
      if (index != -1) {
        $scope.importSelected.splice(index, 1);
      }
    }

    $scope.validateAllResourceItems = function () {
      $scope.importList.forEach($scope.validateResourceItem)
    }

    $scope.validateResourceItem = function (resource) {
      var error = false;
      if (resource.category == null || resource.category.id == null) {
        error = true;
      }

      if (resource.uom == null || resource.uom.id == null) {
        error = true;
      }

      if (resource.name == null || resource.name == '') {
        error = true;
      }

      if (
        resource.identifier == null
        || resource.identifier == ''
      ) {
        error = true;
      }

      if (
        $scope.allResources.map(resource => resource.identifier).includes(resource.identifier)
        || _.without($scope.importList, resource).map(resource => resource.identifier).includes(resource.identifier)
      ) {
        error = true
        resource.identifierNotUnique = true
      } else {
        resource.identifierNotUnique = false
      }

      if (error) {
        resource.error = true;
        resource.selected = false;
      } else {
        resource.error = false;
        resource.selected = true;
      }

      return resource.error;
    }

    $scope.toggleRowItem = function (item) {
      if (item.selected) {
        item.selected = false;
      } else {
        item.selected = true;
      }
    }

  })



// WEBPACK FOOTER //
// ./src/controllers/modals/importResourcesModalController.js